<div
  *transloco="let t; scope: 'featureDataManagement'"
  [formGroup]="categoryForm"
>
  <div
    data-id="manage-attributes-category-title"
    class="bd-body-regular pb-2 mt-10"
  >
    {{ t('featureDataManagement.manageAttributes.category') }}
  </div>
  <div class="flex flex-wrap my-3 gap-8">
    <div class="flex items-center">
      <p-radiobutton
        data-id="manage-attributes-radio-existing-category"
        inputId="existingCategoryRadioButton"
        formControlName="selectNewCategory"
        [value]="false"
        (onClick)="onSelectNewCategoryChange()"
        class="flex"
      ></p-radiobutton>
      <label class="ml-2 bd-body-regular" for="existingCategoryRadioButton">{{
        t(
          'featureDataManagement.manageAttributes.selectExistingCategoryRadioLabel'
        )
      }}</label>
    </div>
    <div class="flex items-center">
      <p-radiobutton
        data-id="manage-attributes-radio-create-new-category"
        inputId="createNewCategory"
        formControlName="selectNewCategory"
        [value]="true"
        (onClick)="onSelectNewCategoryChange()"
        class="flex"
      ></p-radiobutton>
      <label class="ml-2 bd-body-regular" for="createNewCategory">{{
        t('featureDataManagement.manageAttributes.createCategoryRadioLabel')
      }}</label>
    </div>
  </div>

  @if (isNewCategorySelected) {
    @let newCategoryControlHasError =
      newCategoryControl.invalid &&
      (newCategoryControl.dirty || newCategoryControl.touched);

    <div class="flex flex-col gap-2 mt-4">
      <label for="newCategory" class="bd-label-small-gray">{{
        t('featureDataManagement.manageAttributes.createCategoryInputLabel')
      }}</label>

      <p-inputgroup>
        <input
          data-id="manage-attributes-new-category-input"
          id="newCategory"
          pInputText
          formControlName="newCategoryName"
          type="text"
          autocomplete="off"
          [placeholder]="
            t(
              'featureDataManagement.manageAttributes.newCategoryInputPlaceholder'
            )
          "
          [ngClass]="{
            'ng-dirty ng-invalid': newCategoryControlHasError,
          }"
          (keydown.enter)="onConfirmCategoryName()"
          (blur)="onConfirmCategoryName()"
        />
        <div class="bd-right-icons">
          @if (
            newCategoryControl.value &&
            (newCategoryControl.dirty || newCategoryControl.touched)
          ) {
            <p-button
              data-id="clear-category-name"
              (onClick)="onClearCategoryNameClick()"
              [text]="true"
              styleClass="bd-neutral bd-size-small"
              class="flex items-center"
              icon="ui-close"
              [disabled]="!newCategoryControl.value"
              [ariaDisabled]="!newCategoryControl.value"
            />
          }
          @if (newCategoryControlHasError) {
            <i
              class="ui-error bd-icon bd-right-icon bd-error-icon"
              data-id="input-error-icon"
            ></i>
          }
        </div>
      </p-inputgroup>
      @if (newCategoryControlHasError) {
        @for (key of errorKeys; track key) {
          @if (newCategoryControl.errors?.[key]) {
            <bd-helper-text
              [text]="
                t(
                  `featureDataManagement.manageAttributes.validation.categoryName.${key}`
                )
              "
              [state]="'error'"
            />
          }
        }
      }
    </div>
  } @else {
    <div class="flex flex-col gap-2 mt-4">
      <label for="existingCategoryDropDown" class="bd-label-small-gray">
        {{
          t(
            'featureDataManagement.manageAttributes.selectCategoryDropdownLabel'
          )
        }}
      </label>
      <p-select
        [emptyMessage]="
          t(
            'featureDataManagement.manageAttributes.selectExistingCategoryDropdownNoResults'
          )
        "
        id="existingCategoryDropDown"
        data-id="manage-attributes-existing-category-dropdown"
        [options]="existingCategories?.categories ?? []"
        optionLabel="name"
        optionValue="id"
        [placeholder]="
          t(
            'featureDataManagement.manageAttributes.categoryDropdownPlaceholder'
          )
        "
        [optionDisabled]="'readOnly'"
        class="bd-label-regular w-full"
        formControlName="existingCategoryName"
        (onChange)="onCategorySelectionChange($event)"
      >
        <ng-template let-category #item>
          @if (category.readOnly) {
            <div
              [pTooltip]="
                t(
                  'featureDataManagement.manageAttributes.dropdownCategoryDisabledTooltip',
                  { categoryName: category.name }
                )
              "
              tooltipPosition="right"
              [ariaDisabled]="true"
              class="bd-disabled-option-tooltip"
              (click)="onDisabledOptionClick($event)"
              (keydown.enter)="onDisabledOptionClick($event)"
            >
              {{ category.name }}
            </div>
          } @else {
            <div>
              {{ category.name }}
            </div>
          }
        </ng-template>
      </p-select>
    </div>
  }
</div>
